import React, {lazy, Suspense} from 'react'

const ProductLandingPageLazy = lazy(() =>
    import('./ProductLandingPage')
)

const ProductLandingPage = props => (
    <Suspense fallback={null}>
        <ProductLandingPageLazy {...props} />
    </Suspense>
)

export default ProductLandingPage
